/*
 * Filename: form-control-configuration-panel.component.tsx
 * Description: Page section holds fields level configuration information
 */

import React, { Component, ReactNode, BaseSyntheticEvent } from 'react';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { observer } from 'mobx-react';
import { GridRowStdVisibilityRuletModal } from '../row-actions/std-row-visibility-rule-modal.component';
import { CQAppStore } from '../../../../../store/cq-app-store';
import GridTemplateConfigurationController from '../../grid-template-config.controller';
import { TemplateSFObjectStore } from '../../../../../store/models/template-object.model';
import { AppliedRuleGridComponent } from '../../grid-applied-rule.component';
import { GridActionsReducer } from '../action-controller/grid-actions.reducer';
import { ActionMapperController } from '../action-controller/action-mapper';
export class StandardRowActionComponent
    extends Component<{ selectedTemplateName: string, action: any }, any> {

    private gridController: GridTemplateConfigurationController;
    private gridActionsReducer: GridActionsReducer;
    constructor(props: Readonly<{ selectedTemplateName: string, action: any }>) {
        super(props);
        this.gridController = new GridTemplateConfigurationController();
        this.gridActionsReducer = new GridActionsReducer();
        this.state = this.gridController.initializeStandardRowState();
    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps && nextProps.action.name !== this.props.action.name) {
            CQAppStore.loader.setVisibility(true);
            const selectedAction = CQMasterDataStore.GridObject.selectedRowAction;
            const ruleElements = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
            const gridObj = ruleElements.hasOwnProperty('gridObject') ? ruleElements.gridObject : {};
            const rowActions = gridObj.hasOwnProperty('rowActions') ? gridObj.rowActions : {};
            if (rowActions.hasOwnProperty(selectedAction.name)) {
                const ruleObject = { ...rowActions[selectedAction.name] };
                this.setState({
                    isApplyRuleModalVisisble: ruleObject.isApplyRuleModalVisisble,
                    label: ruleObject.label,
                    isFormValid: ruleObject.isFormValid,
                    isActionSaved: ruleObject.isActionSaved,
                    rowActionType: 'standard_row_action',
                    isRuleApplied: ruleObject.isRuleApplied,
                    visibilityRuleObj: ruleObject.visibilityRuleObj,
                    name: ruleObject.name,
                    visibilityRuleFields: ruleObject.visibilityRuleFields,
                    isVisible: ruleObject.isVisible,
                    parentFields: ruleObject.parentFields,
                }, () => CQAppStore.loader.setVisibility(false));
            } else {
                this.setState({
                    name: selectedAction.name,
                    label: selectedAction.name,
                    isApplyRuleModalVisisble: false,
                    isFormValid: false,
                    isActionSaved: false,
                    isRuleApplied: false,
                    visibilityRuleObj: {},
                    visibilityRuleFields: [],
                    isVisible: false,
                    parentFields: [],
                }, () => CQAppStore.loader.setVisibility(false));
            }
        } 
    }

    async componentDidMount() {
        CQAppStore.loader.setVisibility(true);
        const selectedAction = CQMasterDataStore.GridObject.selectedRowAction;
        const ruleElements = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        const gridObj = ruleElements.hasOwnProperty('gridObject') ? ruleElements.gridObject : {};
        const rowActions = gridObj.hasOwnProperty('rowActions') ? gridObj.rowActions : {};
        if (rowActions.hasOwnProperty(selectedAction.name)) {
            const ruleObject = { ...rowActions[selectedAction.name] };
            this.setState({
                isApplyRuleModalVisisble: ruleObject.isApplyRuleModalVisisble,
                label: ruleObject.label,
                isFormValid: ruleObject.isFormValid,
                rowActionType: 'standard_row_action',
                isRuleApplied: ruleObject.isRuleApplied,
                visibilityRuleObj: ruleObject.visibilityRuleObj,
                name: ruleObject.name,
                visibilityRuleFields: ruleObject.visibilityRuleFields,
                isVisible: ruleObject.isVisible,
                parentFields: ruleObject.parentFields,
                isActionSaved: ruleObject.isActionSaved,
            }, () => CQAppStore.loader.setVisibility(false));
        } else {
            this.setState({
                name: selectedAction.name,
                label: selectedAction.name
            }, () => CQAppStore.loader.setVisibility(false));
        }
        CQAppStore.loader.setVisibility(false);
    }

    public render(): ReactNode {
        const selectedRowAction = CQMasterDataStore.GridObject.selectedRowAction;
        const { ruleObject }: any = this.extractStoreData();
        return (
            <>
                <div className="slds-col config-sidebar full-height">
                    <div className="bg-white full-height slds-p-around_small">
                        <div className="slds-grid slds-grid_vertical">
                            <h2 className="slds-text-heading_small slds-m-bottom_medium">Row Actions</h2>
                            <dl className="slds-dl_horizontal slds-m-bottom_medium">
                                <dt className="slds-dl_horizontal__label">Standard Action</dt>
                            </dl>
                            <div className="slds-grid slds-grid_vertical full-height scroll-content">
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label">Name</label>
                                    <div className="slds-form-element__control">
                                        <input type="text" id="" placeholder="Add Name" disabled={true} value={`std_new_${(selectedRowAction.name).toLowerCase()}`}
                                             className="slds-input" />
                                    </div>
                                </div>
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label">Label</label>
                                    <div className="slds-form-element__control">
                                        <input type="text" id="" placeholder="Add Label" disabled={true} value={selectedRowAction.name}
                                             className="slds-input" />
                                    </div>
                                </div>
                                <div>
                                    {
                                        this.state.isRuleApplied ? <AppliedRuleGridComponent ruleObject={ruleObject} toggleModalVisibility={this.toggleRuleModalVisibility} deleteRule={this.deleteRule} /> : <button className="slds-button slds-button_brand full-width slds-m-bottom_small"
                                            onClick={() => { this.toggleRuleModalVisibility(); }}>Add Rule</button>
                                    }
                                    {/* <button disabled={!this.state.isRuleApplied} className="slds-button slds-button_brand full-width"
                                        onClick={this.updateStandardAction}>{ruleObject && ruleObject.hasOwnProperty('isActionSaved') && ruleObject.isActionSaved ? `Update Standard Action` : `Save Standard Action`}</button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.state.isApplyRuleModalVisisble && <GridRowStdVisibilityRuletModal
                        selectedTemplateName={this.props.selectedTemplateName}
                        toggleModalVisibility={this.toggleRuleModalVisibility}
                        ruleObject={ruleObject}
                        actionType={selectedRowAction.name}
                        updateVisibilityRuleObj={this.updateVisibilityRuleObj}
                    />
                }
            </>
        );
    }

    public updateVisibilityRuleObj = (isRuleApplied: boolean, visibilityRuleObj: any, fields: any, isVisible: string, parentFields: any, additionalFieldsArray: any) => {
        this.setState({
            isRuleApplied,
            visibilityRuleObj,
            visibilityRuleFields: fields,
            isVisible,
            parentFields,
            additionalFieldsArray
        },()=>{
            this.updateStandardAction();
        });
    }

    /**
     * @private
     * @memberof StandardRowActionComponent
     */
    private extractStoreData = () => {
        let ruleObject = {};
        const selectedRowAction = CQMasterDataStore.GridObject.selectedRowAction;
        const outputConfig: any = CQMasterDataStore.OutputConfig;
        const ruleElements = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        const gridObj = ruleElements.hasOwnProperty('gridObject') ? ruleElements.gridObject : {};
        const rowActions = gridObj.hasOwnProperty('rowActions') ? gridObj.rowActions : {};
        if (rowActions.hasOwnProperty(this.state.name)) {
            ruleObject = rowActions[this.state.name];
        }
        return { ruleObject, gridObj };
    }

    public deleteRule = () => {
        const selectedRowAction = CQMasterDataStore.GridObject.selectedRowAction;
        this.gridActionsReducer.deleteViewModel(selectedRowAction.name, this.props.selectedTemplateName, 'rowActions');
        this.updateVisibilityRuleObj(false, {}, [], 'false', [], []);
        const outputConfig: any = CQMasterDataStore.OutputConfig;
        let rowFormRules = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'rowFormRules');
        if (rowFormRules.hasOwnProperty(this.state.name)) {
            delete rowFormRules[this.state.name];
        }
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'rowFormRules', rowFormRules);
    }


    /**
     * @private
     * @memberof CQGridControlConfiguration
     */
    private toggleRuleModalVisibility = () => {
        this.setState({
            isApplyRuleModalVisisble: !this.state.isApplyRuleModalVisisble
        });
    }

    private updateStandardAction = () => {
        CQAppStore.loader.setVisibility(true);
        this.setState({
            isActionSaved: true
        }, () => {
            const outputConfig: any = CQMasterDataStore.OutputConfig;
            let ruleElementsObj = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
            let gridObj = { ...ruleElementsObj.gridObject };
            let rowActions = { ...gridObj.rowActions };
            rowActions[this.state.name] = { ...rowActions[this.state.name], ...this.state };
            gridObj.rowActions = rowActions;
            ruleElementsObj.gridObject = gridObj;
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'ruleElements', ruleElementsObj);
            // store row action rules in FieldRuleElement to avoid being overwritten incase user adds Grid component event rules.
            CQMasterDataStore.RuleElements.addGridObject(ruleElementsObj);
            const actionObject: any = ActionMapperController[this.state.rowActionType].getControllerInstance(this.state);
            this.saveDataToStore(actionObject);
            this.saveToOrderingList(actionObject);
            setTimeout(() => { CQAppStore.loader.setVisibility(false); }, 2000);
        });
    }

    private saveToOrderingList = (actionObject: any) => {
        let orderedRowAction = [...CQMasterDataStore.GridObject.orderedRowAction];
        if (!actionObject.actionJSON.hasOwnProperty('rowFormRules')) {
            const ifExist = orderedRowAction.length && orderedRowAction.map((orderedAction: any, index: number) => {
                let action = { ...orderedAction };
                if (action.actionJSON.hasOwnProperty('rowActions') && action.actionJSON.rowActions.name === this.state.name) {
                    orderedRowAction[index] = actionObject;
                    return true;
                }
                return false;
            });
            if (!ifExist) {
                orderedRowAction.push(actionObject);
            }
            CQMasterDataStore.GridObject.updateGridField('orderedRowAction', orderedRowAction);
        } else {
            orderedRowAction.forEach((orderedAction: any, index: number) => {
                let action = { ...orderedAction };
                if (action.actionJSON.hasOwnProperty('rowActions') && action.actionJSON.rowActions.name === this.state.name) {
                    orderedRowAction.splice(index, 1);
                }
            });
            CQMasterDataStore.GridObject.updateGridField('orderedRowAction', orderedRowAction);
        }

    }

    private saveDataToStore = (actionObject: any) => {
        const outputConfig = CQMasterDataStore.OutputConfig.getStoreData(this.props.selectedTemplateName);
        actionObject && Object.keys(actionObject.actionJSON).length && Object.keys(actionObject.actionJSON).map((objKey: string) => {
            if (objKey === 'rowFormRules') {
                const rowFormRules = { ...outputConfig.rowFormRules, ...actionObject.actionJSON[objKey] };
                CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, objKey, rowFormRules);
            } else if (objKey === 'rowActions') {
                const rowActions = [...outputConfig.rowActions];
                rowActions.push({ ...actionObject.actionJSON[objKey] })
                CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, objKey, rowActions);
            }
        });
        const parentFields = [...outputConfig.parentFields, ...this.state.parentFields];
        const parentFieldsArray = Array.from(new Set(parentFields));
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'parentFields', parentFieldsArray);
    }
}

export const StandardRowActionComponentRootComponent = observer(
    StandardRowActionComponent
);